import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { newsletterAPI } from '../../utils/api';
import toast from 'react-hot-toast';

export default function Footer() {
  const [email, setEmail] = useState('');
  const handleSubscribe = async (e) => {
    e.preventDefault();
    try { await newsletterAPI.subscribe(email); toast.success('U regjistruat me sukses! 🌿'); setEmail(''); } catch { toast.error('Gabim'); }
  };
  return (
    <footer className="site-footer">
      <div className="footer-main">
        <div className="footer-brand">
          <div className="footer-logo">HairFix <span>Naturals</span></div>
          <p>Formula natyrale premium — pa kompromis, pa kimikate, vetëm rezultate të vërteta.</p>
          <div className="footer-socials">
            <a href="https://www.instagram.com/hairfixnaturals" target="_blank" rel="noreferrer">📸</a>
            <a href="https://www.facebook.com/share/1Kw6BEQArR/" target="_blank" rel="noreferrer">👤</a>
            <a href="https://www.tiktok.com/@hairfixnaturals" target="_blank" rel="noreferrer">🎵</a>
          </div>
        </div>
        <div>
          <div className="footer-heading">Produktet</div>
          <ul><li><Link to="/shop">Të Gjitha</Link></li><li><Link to="/shop?category=eliksire">Eliksirë</Link></li><li><Link to="/shop?category=shampoo">Shampoo</Link></li></ul>
        </div>
        <div>
          <div className="footer-heading">Kompania</div>
          <ul><li><Link to="/blog">Blog</Link></li><li><Link to="/orders">Porositë</Link></li></ul>
        </div>
        <div>
          <div className="footer-heading">Newsletter</div>
          <p style={{ fontSize:'.82rem',color:'rgba(255,255,255,.5)',marginBottom:12 }}>Merr oferta ekskluzive dhe këshilla për kujdesin e flokëve.</p>
          <form onSubmit={handleSubscribe} style={{ display:'flex',gap:8 }}>
            <input type="email" required placeholder="email@juaj.com" value={email} onChange={e => setEmail(e.target.value)} style={{ flex:1,padding:'10px 14px',borderRadius:'var(--radius-full)',border:'1px solid rgba(255,255,255,.15)',background:'rgba(255,255,255,.08)',color:'white',fontSize:'.85rem',outline:'none' }} />
            <button type="submit" className="btn btn-gold btn-sm">→</button>
          </form>
        </div>
      </div>
      <div className="footer-bottom">
        <span>© 2025 HairFix Naturals SH.P.K. Të gjitha të drejtat e rezervuara.</span>
        <div style={{ display:'flex',gap:12 }}>
          {['100% Natyral','Pa Sulfate','Cruelty Free'].map(b => <span key={b} style={{ padding:'3px 10px',border:'1px solid rgba(255,255,255,.15)',borderRadius:'999px',fontSize:'.68rem',color:'rgba(255,255,255,.35)',letterSpacing:'.04em',textTransform:'uppercase' }}>{b}</span>)}
        </div>
      </div>
      <style>{`
        .site-footer{background:#0F2318;color:rgba(255,255,255,.55);padding:60px 48px 32px;}
        .footer-main{max-width:1200px;margin:0 auto;display:grid;grid-template-columns:2fr 1fr 1fr 1.5fr;gap:48px;margin-bottom:48px;}
        .footer-logo{font-family:'Playfair Display',serif;font-size:1.2rem;font-weight:700;color:white;margin-bottom:12px;}
        .footer-logo span{color:var(--gold);font-style:italic;}
        .footer-brand p{font-size:.82rem;line-height:1.7;margin-bottom:18px;}
        .footer-socials{display:flex;gap:10px;}
        .footer-socials a{width:36px;height:36px;border-radius:50%;background:rgba(255,255,255,.08);color:white;display:flex;align-items:center;justify-content:center;font-size:.9rem;transition:background .2s;}
        .footer-socials a:hover{background:var(--gold);color:var(--green-deep);}
        .footer-heading{font-size:.72rem;font-weight:700;letter-spacing:.08em;text-transform:uppercase;color:white;margin-bottom:14px;}
        .site-footer ul{list-style:none;}
        .site-footer ul li{margin-bottom:9px;}
        .site-footer ul a{font-size:.82rem;color:rgba(255,255,255,.5);transition:color .2s;}
        .site-footer ul a:hover{color:var(--gold-light);}
        .footer-bottom{max-width:1200px;margin:0 auto;padding-top:28px;border-top:1px solid rgba(255,255,255,.08);display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap;gap:12px;font-size:.78rem;}
        @media(max-width:768px){.footer-main{grid-template-columns:1fr;gap:32px;}.site-footer{padding:40px 24px 28px;}}
      `}</style>
    </footer>
  );
}
